import { render, staticRenderFns } from "./avatar_modal.vue?vue&type=template&id=6bd00865&scoped=true&"
import script from "./avatar_modal.vue?vue&type=script&lang=js&"
export * from "./avatar_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd00865",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd00865')) {
      api.createRecord('6bd00865', component.options)
    } else {
      api.reload('6bd00865', component.options)
    }
    module.hot.accept("./avatar_modal.vue?vue&type=template&id=6bd00865&scoped=true&", function () {
      api.rerender('6bd00865', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/user/profile/tabs/avatar/avatar_modal.vue"
export default component.exports